export default __webpack_public_path__ + "static/media/pb_cnpq.813ae554.jpeg";